::ng-deep .leaflet-control-container .leaflet-control-attribution.leaflet-control{display:none!important}.my-leaflet-map-container img{max-height:100%}
/*# sourceMappingURL=dashboard-maps.component-KVXFYLEM.css.map */
